import { ServicesTable } from "../../../../pages/Services/ServicesTable/ServicesTable";
import { Form } from "react-bootstrap";

export const recommendationsTable = (recommendations, phases, columns) => {
  return (
    <>
      {phases.map((p, i) => (
        <div key={i} className="phaseContainer">
          <div className="phaseHeader">{p?.name || ""}</div>
          <Form>
            <ServicesTable
              servicesPassed={
                recommendations?.filter((s) => s?.phase?.id === p?.id) || [
                  { id: "0", name: "No services found" },
                ]
              }
              onUpdateServices={(services) => null}
              serviceColumns={
                p?.name !== "Managed Services"
                  ? columns
                  : columns.filter((column) => column.id !== "resource")
              }
              subserviceColumns={
                p?.name !== "Managed Services"
                  ? columns
                  : columns.filter((column) => column.id !== "resource")
              }
              areSurveyRecommendations
            />
          </Form>
        </div>
      ))}
    </>
  );
};
